import BaseComponent from './BaseComponent';

class InputEmail extends BaseComponent {
  constructor(componentName, autoInit){
    super(componentName);
  }


  init(component) {
    // this.addCustomEvents(component);
  }


  addCustomEvents(component) {}
}

export default InputEmail;
